// Third Party Library Imports
import { Form, Input, Select } from "antd";
import clsx from "clsx";
import { PhoneInput } from "react-international-phone";
import ReactCountryFlag from "react-country-flag";
import TextArea from "antd/es/input/TextArea";

// Local Imports
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";

const { Option } = Select;

const ContactPersonForm: React.FC<any> = ({
  person,
  index,
  standingData,
  countriesList,
  setSelectedContactPerson,
  setOpenDeleteModal,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  return (
    <Form
      className="add-edit-form"
      scrollToFirstError={true}
      name={`formPerson${index}`}
      form={form}
      initialValues={{
        id: person?.id,
        prefixId: person?.prefix?.id || person?.prefixId,
        fullName: person?.fullName,
        relationshipId: person?.relationshipId,
        email: person?.email,
        countryId: person?.countryId,
        mobileNumber: person?.mobileNumber,
        details: person?.details,
      }}
    >
      <div className="fields flex justify-between flex-wrap">
        <div className="field flex-col hidden">
          <Label text="ID" />
          <Form.Item
            name="id"
            hidden
            rules={[
              {
                required: true,
                message: "Please input Full name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="field flex flex-col">
          <Label text="Title" />
          <Form.Item
            name="prefixId"
            rules={[
              {
                required: true,
                message: "Please input Full name!",
              },
            ]}
          >
            <Select
              placeholder="Select title"
              options={standingData?.title?.map((item: any) => ({
                label: item.description,
                value: item.id,
              }))}
            />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Full name" />
          <Form.Item
            name="fullName"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please input Full name!",
              },
            ]}
          >
            <CustomInput placeholder="Enter Full name" />
          </Form.Item>
        </div>
        <div className="field flex flex-col">
          <Label text="Country" />
          <Form.Item
            name="countryId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select country!",
              },
            ]}
          >
            <Select placeholder="Select Country" allowClear showSearch>
              {countriesList?.map((country: any) => (
                <Option value={country.id} key={country.nameEn}>
                  <div className="flex items-center gap-1">
                    <ReactCountryFlag
                      style={{
                        fontSize: "24px",
                        marginInlineEnd: "8px",
                      }}
                      countryCode={country?.countryCode}
                      svg
                    />
                    <span>{country.nameEn}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="field flex flex-col">
          <Label text="Phone Number" />
          <Form.Item
            name="mobileNumber"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please input Phone Number!",
              },
            ]}
          >
            <div className="phone-input">
              <PhoneInput
                placeholder="Enter Phone Number"
                value={person?.mobileNumber || ""}
                defaultCountry="kw"
                // onChange={() => setValue("")}
              />
              <span className="sub-text">
                Phone number format: countrycode-phone (Example: +965-00000000)
              </span>
            </div>
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Relationship" />
          <Form.Item
            name="relationshipId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please input Relationship!",
              },
            ]}
          >
            <Select
              placeholder="Select relationship"
              options={standingData?.CONTACT_RELATION?.map((item: any) => ({
                label: item.description,
                value: item.id,
              }))}
            />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Email" />
          <Form.Item
            name="email"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please input email!",
              },
              {
                type: "email",
                message: "Please enter a valid email!",
              },
            ]}
          >
            <CustomInput placeholder="Enter email" />
          </Form.Item>
        </div>
        <div className="fields flex column">
          <Label text="Additional Information" />
          <Form.Item name="details" validateTrigger={["onChange", "onBlur"]}>
            <TextArea rows={4} placeholder="Enter details" />
          </Form.Item>
        </div>
      </div>
      <div className="flex w-full flex-wrap items-center justify-end mt-7 border-t-[1px] border-gray-900 pt-5">
        <div
          className={clsx(
            "flex items-center w-[70%] md:w-[48%]",
            person?.id ? "justify-between" : "justify-end"
          )}
        >
          {person?.id && (
            <button
              type="button"
              onClick={() => {
                setSelectedContactPerson(person);
                setOpenDeleteModal(true);
              }}
              className="rounded-lg bg-red-200 text-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-red-200"
            >
              Delete
            </button>
          )}
          <button
            type="button"
            onClick={() => onSubmit(form.getFieldsValue())}
            className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
          >
            Save
          </button>
        </div>
      </div>
    </Form>
  );
};

export default ContactPersonForm;
